import classNames from 'classnames';
import React, { MutableRefObject } from 'react';
import { Button } from 'src/common/button';
import { Content } from 'src/common/interfaces/content.interface';
import { useFilesUploadStore } from 'src/common/store/files-upload.store';
import { Nullable } from 'src/types/nullable.type';
import { WizardContentCardsType } from '../screen';
import { WizardContentListCardFactory } from './card/factory';

const gradientClasses =
  'after:absolute after:inset-y-0 after:w-full after:h-[calc(100vh-11.5rem)] after:bg-gradient-to-t after:from-bedrock-light-gray after:to-[rgba(244, 244, 245, 1)] after:pointer-events-none';

export interface Props {
  cards: WizardContentCardsType;
  showBuildCard: boolean;
  onDeleteContent: (contentId: Content['id']) => void;
  lastElementRef: MutableRefObject<Nullable<HTMLDivElement>>;
  onCreateJourneyClick: () => void;
}

export const WizardContentListContainer = ({
  cards,
  onCreateJourneyClick,
  lastElementRef,
  showBuildCard,
  onDeleteContent,
}: Props) => {
  const disableCreateJourney = useFilesUploadStore((state) => state.getOngoingUploadStacks().length !== 0);
  return (
    <div
      className={classNames(
        'relative w-full overflow-hidden flex flex-col p-6 justify-between text-bedrock-black rounded-lg bg-bedrock-light-gray transition-opacity',
        {
          'opacity-100': showBuildCard,
          'opacity-0 pointer-events-none': !showBuildCard,
        }
      )}
    >
      <div className='flex h-full flex-col gap-2 overflow-auto scrollbar-hidden mb-16'>
        <span className='text-bedrock-p-strong'>Build Journey using</span>
        <div className={classNames('relative h-full', gradientClasses)}>
          <div className='flex flex-col h-full gap-2'>
            {cards.map((card, index) => {
              const CardComponent = WizardContentListCardFactory(card, {
                onDeleteClick: () => onDeleteContent(index),
              });
              return <CardComponent key={index} />;
            })}
            <div ref={lastElementRef} className='h-px bg-bedrock-light-gray' />
          </div>
        </div>
      </div>
      <div className='absolute inset-x-0 bottom-0 bg-bedrock-light-gray p-6 pt-0 z-50'>
        <Button
          onClick={onCreateJourneyClick}
          disabled={disableCreateJourney}
          size='regular'
          variant='primary'
          className='w-full'
          label='Create Journey'
        />
      </div>
    </div>
  );
};
